<!-- app-header -->
<header class="app-header">
    <!-- Start::main-header-container -->
    <div class="main-header-container container-fluid">
        <!-- Start::header-content-left -->
        <div class="header-content-left align-items-center">

            <!-- Start::header-element -->
            <div class="header-element">
                <div class="horizontal-logo">
                    <a [routerLink]="['/dashboards/dashboard']" class="header-logo">
                        <img src="./assets/images/brand-logos/desktop-logo.png" alt="logo" class="desktop-logo">
                        <img src="./assets/images/brand-logos/toggle-logo.png" alt="logo" class="toggle-logo">
                        <img src="./assets/images/brand-logos/desktop-dark.png" alt="logo" class="desktop-dark">
                        <img src="./assets/images/brand-logos/toggle-dark.png" alt="logo" class="toggle-dark">
                        <img src="./assets/images/brand-logos/desktop-white.png" alt="logo" class="desktop-white">
                        <img src="./assets/images/brand-logos/toggle-white.png" alt="logo" class="toggle-white">
                    </a>
                </div>
            </div>
            <!-- End::header-element -->

            <!-- Start::header-element -->
            <div class="header-element">
                <!-- Start::header-link -->
                <a (click)="toggleSidebar()" aria-label="Hide Sidebar" class="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle" data-bs-toggle="sidebar" href="javascript:void(0);"><span></span></a>
                <!-- End::header-link -->
            </div>
            <!-- End::header-element -->

            <div class="ms-3 d-flex align-items-center gap-3">

                <!-- RUNNING JOB -->
                <div *ngIf="runningJob" class="d-none d-lg-flex d-xl-flex align-items-center gap-2">

                    <div
                            class="spinner-border spinner-border-sm text-primary"
                            role="status">
                    </div>

                    <div class="d-flex flex-column">
                        <small class="text-muted">
                            Analyzing conversation...
                        </small>

                        <small class="fw-semibold text-truncate"
                               style="max-width: 180px;"
                               [title]="runningJob.final_conversation_title || runningJob.filename">
                            {{ formatters.truncateConversationTitle(
                            runningJob.final_conversation_title || runningJob.filename,
                            20
                        ) }}
                        </small>
                    </div>

                    <span class="badge bg-light text-dark">
                        {{ remainingTime$ | async }}
                    </span>
                </div>

                <!-- FINISHED ANALYSES -->
                <div *ngIf="showConversationSelector && analyses.length > 0"
                     class="d-none d-md-block d-lg-block d-xl-block header-element header-search custom-header-searchInput  ms-3">

                    <mat-form-field
                            class="header-conversation-select"
                            appearance="fill"
                            *ngIf="showConversationSelector && analyses.length > 0">

                        <mat-label>Conversation</mat-label>

                        <mat-select
                                [(value)]="selectedJobId"
                                (selectionChange)="onSelectAnalysis($event.value)"
                                [matTooltip]="selectedAnalysis?.finalConversationTitle || ''"
                                matTooltipPosition="above"
                        >

                            <mat-option
                                    *ngFor="let a of analyses; trackBy: trackByJob"
                                    [value]="a.jobId"
                                    [matTooltip]="a.finalConversationTitle || ('Conversation ' + a.jobId)"
                                    matTooltipPosition="right"
                            >
                                {{
                                    formatters.truncateConversationTitle(
                                        a.finalConversationTitle || ('Conversation ' + a.jobId),
                                        20
                                    )
                                }}
                            </mat-option>

                        </mat-select>
                    </mat-form-field>

                </div>
            </div>
            <!--div class="d-flex gap-2 ms-3" *ngIf="analyses.length">

                <button
                        *ngFor="let a of analyses"
                        class="btn btn-sm"
                        [class.btn-primary]="a.jobId === selectedJobId"
                        [class.btn-outline-primary]="a.jobId !== selectedJobId"
                        (click)="onSelectAnalysis(a.jobId)"
                >
                    {{ a.filename || ('Job ' + a.jobId) }}
                </button>

            </div-->
        </div>
        <!-- End::header-content-left -->

        <!-- Start::header-content-right -->
        <div class="header-content-right">
            <!-- Start::header-element -->
            <div ngbDropdown  class="header-element country-selector">
                <!-- Start::header-link|dropdown-toggle -->
                <a
                        ngbDropdownToggle
                        href="javascript:void(0);"
                        class="header-link dropdown-toggle"
                        data-bs-auto-close="outside"
                        data-bs-toggle="dropdown"
                >
                    <!-- Start::header-link-icon -->
                    <i class="fe fe-globe header-link-icon"></i>
                    <!-- End::header-link-icon -->
                </a>
                <!-- End::header-link|dropdown-toggle -->
                <ul
                        ngbDropdownMenu
                        class="main-header-dropdown dropdown-menu dropdown-menu-end cart-dropdown-menu"
                        data-popper-placement="none"
                >
                    <li>
                        <a
                                ngbDropdownItem
                                class="dropdown-item d-flex align-items-center"
                                href="javascript:void(0);"
                        >
              <span class="avatar avatar-xs lh-1 me-2">
                <img src="../../../../assets/images/flags/us_flag.png" alt="img" />
              </span>
                            English
                        </a>
                    </li>
                </ul>
            </div>
            <!-- End::header-element -->


            <!-- Start::header-element -->
            <!-- ======>THEME MODE <====== ->
          <div class="header-element header-theme-mode">
            &lt;!&ndash; Start::header-link|layout-setting &ndash;&gt;
            <a href="javascript:void(0);" class="header-link layout-setting">
              <span class="light-layout" (click)="updateTheme('dark')">
                &lt;!&ndash; Start::header-link-icon &ndash;&gt;
                <i class="bx bx-moon header-link-icon"></i>
                &lt;!&ndash; End::header-link-icon &ndash;&gt;
              </span>
              <span class="dark-layout">
                &lt;!&ndash; Start::header-link-icon &ndash;&gt;
                <i
                  class="bx bx-sun header-link-icon"
                  (click)="updateTheme('light')"
                ></i>
                &lt;!&ndash; End::header-link-icon &ndash;&gt;
              </span>
            </a>
            &lt;!&ndash; End::header-link|layout-setting &ndash;&gt;
          </div>-->
            <!-- End::header-element -->


            <!-- Start::header-element -->
            <div class="header-element header-fullscreen" appFullscreen>
                <!-- Start::header-link -->
                <a
                        href="javascript:void(0);"
                        class="header-link"
                        (click)="toggleFullscreen()"
                >
                    <i
                            class="bx bx-fullscreen full-screen-open header-link-icon"
                            [ngClass]="{ 'd-none': isFullscreen }"
                    ></i>
                    <i
                            [ngClass]="{ 'd-none': !isFullscreen }"
                            class="bx bx-exit-fullscreen full-screen-close header-link-icon d-none"
                    ></i>
                </a>
                <!-- End::header-link -->
            </div>
            <!-- End::header-element -->

            <!-- ADMIN -->
            <div
                    class="header-element d-none d-lg-block d-xl-block d-md-block" style="padding: 10px;"
                    *ngIf="isAdmin()"
            >
                <a
                        [routerLink]="['/admin', 'validate-users']"
                        class="btn btn-secondary d-flex align-items-center gap-2"
                >
                    <i class="bx bx-shield-quarter"></i>

                    Admin
                </a>
            </div>

            <!-- Start::header-element -->
            <div ngbDropdown class="header-element">
                <!-- Start::header-link|dropdown-toggle -->
                <a
                        ngbDropdownToggle
                        href="javascript:void(0);"
                        class="header-link dropdown-toggle"
                        id="mainHeaderProfile"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="outside"
                        aria-expanded="false"
                >
                    <div class="d-flex align-items-center">
                        <div class="me-sm-2 me-0">
                            <img
                                    src="./assets/images/faces/avatar.png"
                                    alt="img"
                                    width="32"
                                    height="32"
                                    class="rounded-circle"
                            />
                        </div>
                        <div class="d-xxl-block d-none">
                            <p class="fw-semibold mb-0 lh-1">{{profile.first_name}} {{profile.last_name}}</p>
                            <span class="op-7 fw-normal d-block fs-11">{{profile.company}}</span>
                        </div>
                    </div>
                </a>
                <!-- End::header-link|dropdown-toggle -->
                <ul
                        ngbDropdownMenu
                        class="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end"
                        aria-labelledby="mainHeaderProfile"
                >
                    <!--li>
                      <a
                        href="javascript:void(0)"
                        ngbDropdownItem
                        class="dropdown-item d-flex"
                        href="javascript:void(0);"
                        ><i class="ti ti-user-circle fs-18 me-2 op-7"></i>Profile</a
                      >
                    </li>
                    <li>
                      <a
                        ngbDropdownItem
                        class="dropdown-item d-flex"
                        href="javascript:void(0);"
                        ><i class="ti ti-adjustments-horizontal fs-18 me-2 op-7"></i
                        >Settings</a
                      >
                    </li>
                    <li>
                      <a
                        ngbDropdownItem
                        class="dropdown-item d-flex border-block-end"
                        href="javascript:void(0);"
                        ><i class="ti ti-wallet fs-18 me-2 op-7"></i>Bal: $7,12,950</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        ngbDropdownItem
                        class="dropdown-item d-flex"
                        href="javascript:void(0);"
                        ><i class="ti ti-headset fs-18 me-2 op-7"></i>Support</a
                      >
                    </li-->
                    <li>
                        <a
                                ngbDropdownItem
                                class="dropdown-item d-flex"
                                href="javascript:void(0);"
                                (click)="logout()"
                        ><i class="ti ti-logout fs-18 me-2 op-7"></i>Log Out</a
                        >
                    </li>
                </ul>
            </div>
            <!-- End::header-element -->

            <!-- Start::header-element -->
            <!--<div class="header-element">
              &lt;!&ndash; Start::header-link|switcher-icon &ndash;&gt;
              <a
                href="javascript:void(0);"
                class="header-link switcher-icon"
                data-bs-toggle="offcanvas"
                data-bs-target="#switcher-canvas"
                (click)="toggleSwitcher()"
              >
                <i class="bx bx-cog header-link-icon"></i>
              </a>
              &lt;!&ndash; End::header-link|switcher-icon &ndash;&gt;
            </div>-->
            <!-- End::header-element -->
        </div>
        <!-- End::header-content-right -->
    </div>
    <!-- End::main-header-container -->
</header>
<!-- /app-header -->
